import { createSlice } from "@reduxjs/toolkit";

export const ticketPrioritySlice = createSlice({
  name: "ticketPriority",
  initialState: {
    getTicketPriorityResult: false,
    getTicketPriorityLoading: false,
    getTicketPriorityError: false,
    addTicketPriorityResult: false,
    addTicketPriorityLoading: false,
    deleteTicketPriorityResult: false,
  },
  reducers: {
    ticketPriorityReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKETPRIORITY":
          return {
            ...state,
            getTicketPriorityResult: payload.data,
            getTicketPriorityLoading: payload.loading,
            getTicketPriorityError: payload.error,
          };
        case "ADD_TICKETPRIORITY":
          return {
            ...state,
            addTicketPriorityResult: payload.data,
            addTicketPriorityLoading: payload.loading,
          };
        case "DELETE_TICKETPRIORITY":
          return {
            ...state,
            deleteTicketPriorityResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketPriorityReducers } = ticketPrioritySlice.actions;

export default ticketPrioritySlice.reducer;
